import Markdown from '@/components/atoms/markdown';
import Typography from '@/components/atoms/typography';
import Accordion from '@/components/molecules/accordion';

export type ReleaseNotesSectionProps = {
  data?: any;
};
type sectionType = { question: string | undefined; answer: any };

const ReleaseNotesSection = ({ data }: ReleaseNotesSectionProps) => {
  const foundSection = (data?.sections ?? [])?.find((sec: any) => sec?.hasOwnProperty('section_with_nested_faqs'));
  return (
    <div>
      <div
        className={`pb-20 pt-8 sm:pt-10'
            relative mx-auto w-full  px-4 md:px-8 lg:px-10`}
        id="release-notes"
      >
        <Typography
          className={`!font-semibold text-primary-black border-b border-neutral-400 pb-1 text-2xl !leading-[2.375rem] sm:!leading-[3.5rem] lg:border-none`} align='center' >
          {foundSection?.section_with_nested_faqs?.faq_heading}
        </Typography>
        {foundSection?.section_with_nested_faqs?.faqs?.map((_faq: any, index: number) => {
          return (
            <div key={index} className={`w-full`}>
              <Accordion className={`mr-0 border-b border-neutral-400`}>
                <Accordion.Button className="!px-0 !py-4 text-left text-24 font-medium leading-8 text-[#333]">
                  <Typography
                    as="h3"
                    className={`text-[21px] !font-semibold !leading-[2.1rem] text-[#090909] md:!leading-[2rem]`}
                  >
                    {_faq?.title}
                  </Typography>
                </Accordion.Button>
                <Accordion.Panel>
                  {_faq?.accordion?.map((section: sectionType, index: number) => {
                    const isLastItem = index === _faq?.accordion?.length - 1;
                    return (
                      <Accordion
                        className={`mr-0 ${isLastItem && '!border-b-0'} border-b border-neutral-400`}
                        key={index}
                      >
                        <Accordion.Button
                          className={`text-[19px] !px-0 !py-4 text-left font-normal leading-8 text-[#333]`}
                        >
                          <Typography as="h3" className="w-full">
                            {section?.question}
                          </Typography>
                        </Accordion.Button>
                        <Accordion.Panel>
                          <Markdown>{section?.answer}</Markdown>
                        </Accordion.Panel>
                      </Accordion>
                    );
                  })}
                </Accordion.Panel>
              </Accordion>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ReleaseNotesSection;
